import type {
  Tickets,
  WinnerInfo,
  Withdraw,
  WithdrawRequest
} from '@/models/interface/lotteryTickets';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class LotteryTicketsService extends ApiFactory {
  constructor() {
    super('LotteryTickets');
  }
  /**
   * 一鍵領券
   * @param data
   * @returns
   */
  withdraw(data: WithdrawRequest): Promise<ApiDataResponse<Withdraw>> {
    return this.post(`Withdraw`, data);
  }

  /**
   * 取得票券資訊
   * @param status
   * @param startDay
   * @param endDay
   * @returns
   */
  getTicketsInfoList(
    memberId: number,
    page?: number,
    size?: number,
    status?: string[]
  ): Promise<ApiDataResponse<Tickets>> {
    page = 1;
    size = 100;
    status = ['IN_DRAW', 'AVAILABLE'];

    let query = '';
    status.forEach((s) => (query += `&status=${s}`));

    return this.get(`Member/${memberId}?Page=${page}&Size=${size}${query}`);
  }

  /**
   * 取得票券張數
   * @returns
   */
  getAvailabeTicketCount(): Promise<ApiDataResponse<number>> {
    return this.get(`AvailableTickets/Count`);
  }

  /**
   * 該token人員於本期的中獎資訊
   * @returns
   */
  winningTicket(lotteryId: number): Promise<ApiDataResponse<WinnerInfo>> {
    return this.get(`${lotteryId}/Member/WinningTicket`);
  }

  /**
   * 取得已領過的彩票數
   * @returns 
   */
  currentInDrawTickets(): Promise<ApiDataResponse<number>> {
    return this.get(`CurrentInDrawTickets`);
  }
}
